import axios from 'axios';

const apiClient = axios.create({
  timeout: 15000,
  withCredentials: false,
});

function isSessionActive() {
  try {
    return window.sessionStorage.getItem('isAuthenticated') === 'true';
  } catch (_) {
    return false;
  }
}

apiClient.interceptors.request.use((config) => {
  try {
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
  } catch (_) {}
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err && err.response ? err.response.status : null;
    if (status === 401) {
      try {
        window.sessionStorage.removeItem('isAuthenticated');
      } catch (_) {}
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/dashboard') && window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(err);
  }
);

export function toasterFromError(err, defaultMsg) {
  if (!err) return defaultMsg || 'Unexpected error';
  if (err.response && err.response.data) {
    const d = err.response.data;
    if (typeof d === 'string') return d;
    if (d.message) return d.message;
    if (d.detail) return d.detail;
    if (d.error) return d.error;
  }
  if (err.message) return err.message;
  return defaultMsg || 'Network error';
}

export function formatDate(value, { withTime = true, short = false } = {}) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const pad = (n) => String(n).padStart(2, '0');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const day = d.getDate();
  const mon = months[d.getMonth()];
  const year = d.getFullYear();
  const HH = pad(d.getHours());
  const MM = pad(d.getMinutes());
  const SS = pad(d.getSeconds());
  if (short && !withTime) return `${day} ${mon} ${year.toString().slice(-2)}`;
  const datePart = short ? `${day} ${mon}` : `${day} ${mon} ${year.toString().slice(-2)}`;
  return withTime ? `${datePart} ${HH}:${MM}:${SS}` : datePart;
}

export function formatDuration(ms) {
  if (ms == null || ms === undefined || isNaN(Number(ms))) return '';
  const n = Number(ms);
  if (n < 1000) return `${n} ms`;
  if (n < 60000) return `${(n / 1000).toFixed(n < 10000 ? 1 : 0)} sec`;
  const sec = Math.floor(n / 1000);
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m} min ${s} sec`;
}

export function classNames(...args) {
  return args.filter(Boolean).join(' ');
}

export { isSessionActive };
export default apiClient;
